import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AssignStory, Story } from 'src/app/model/story.model';
import { CloudinaryService } from 'src/app/shared/services/cloudinary.service';
import { Dialog } from 'src/app/shared/components/dialog/dialog';
import { StorybookService } from 'src/app/shared/services/storybook.service';
import { MatSelectChange } from '@angular/material/select';
import { RequestEditStory } from 'src/app/model/edit-story.model';

@Component({
  selector: 'app-story-assigned-dialog',
  templateUrl: './story-assigned-dialog.component.html',
  styleUrls: ['./story-assigned-dialog.component.scss']
})
export class StoryAssignedDialogComponent extends Dialog implements OnInit, OnDestroy {

  form: FormGroup;
  allStorybooks: AssignStory[];
  currentStorybooks: AssignStory[];
  username: string ;
  readingLevel: string;
  studentId: string;
  storybookSelected: boolean = false;
  selectedStorybook: AssignStory;

  constructor(
    private dialogRef: MatDialogRef<StoryAssignedDialogComponent>, 
    @Inject(MAT_DIALOG_DATA) private data: any,
    public cloudinaryService: CloudinaryService,
    private storybookService: StorybookService
    ) {
    super({}, dialogRef);
    
  }

  get storyName() { return this.form.get('storyName'); }

  ngOnInit(): void {
    // get dialog data
    this.username = this.data.username;
    this.readingLevel = this.data.readingLevel;
    this.studentId = this.data.studentId;
    // init form
    this.form = new FormGroup({
      storyName: new FormControl('', [Validators.required])
    });
    this.storybookService.getUnAsignedStorybooks(this.studentId)
    .subscribe((response: AssignStory[]) => {
      this.allStorybooks = response;
      //console.log(this.allStorybooks);
      this.filterStoryBooksByLevel();
    });
    this.cloudinaryService.responses = [];
    this.cloudinaryService.uploadToCloudinary();
  }

  filterStoryBooksByLevel(){
    this.currentStorybooks = [];
    for (var i = 0; i < this.allStorybooks.length; i++){
      if(this.allStorybooks[i].storybookReadingLevel == this.readingLevel){
        let storyBook = this.allStorybooks[i];
        this.currentStorybooks.push(storyBook);
      }
    }
  }

  setSelectedStorybook(event: MatSelectChange){
    var selectedStorybookId = event.value;
    this.storybookSelected = false;
    for(var i = 0; i < this.currentStorybooks.length; i++){
      if(this.currentStorybooks[i].storybookId == selectedStorybookId){
        this.selectedStorybook = this.currentStorybooks[i];
        this.selectedStorybook.storyUserName = this.username;
        this.storybookSelected = true;
        break;
      }
    }
  }

  ngOnDestroy(): void {
  }

  submitAndClose() {
    this.dialogRef.close({
      selectedStorybook: this.selectedStorybook
    });
  }

}
